var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.initialValues},scopedSlots:_vm._u([{key:"item.url.after",fn:function({ form }){return [_c('ActionForm',{ref:"action",attrs:{"items":_vm.initialValues && _vm.initialValues.actions ? _vm.initialValues.actions : []}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }